import { get } from 'lodash';
import DSTheme from './theme.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'react';
import '@elliemae/pui-theme';
import 'polished';
import './arithmetic.js';

function mapGap(gutter) {
  if (!gutter) return '0rem';
  if (String(gutter).includes('rem') || String(gutter).includes('px')) return gutter;
  return "".concat(DSTheme.space[gutter]);
}
function mapGutter(gutter) {
  if (!gutter) return '0rem';
  return "".concat(DSTheme.space[gutter], " * 2");
}
function mapSpace(width) {
  if (typeof width === 'string') return get(DSTheme, width) ? "".concat(get(DSTheme, width)) : width;
  return "".concat(width * 100, "%");
}
function fixSpaceGutter(width, gutter) {
  if (!width) return '';
  if (Array.isArray(width)) return width.map(function (w) {
    return "calc(".concat(mapSpace(w), " - (").concat(mapGutter(gutter), "))");
  });
  return "calc(".concat(mapSpace(width), " - (").concat(mapGutter(gutter), "))");
}
function fixSpace(width) {
  if (!width) return '';
  if (Array.isArray(width)) return width.map(function (w) {
    return mapSpace(w);
  });
  return mapSpace(width);
}
/**
 * Grid
 *
 * @param grid
 */

function numbersToFr(grid) {
  var den = grid.map(function (f) {
    return f < 1 ? Math.floor(1 / f) : f;
  });
  return den.map(function (d) {
    return "".concat(d, "fr");
  });
}
function mapGrid(width) {
  if (get(DSTheme, width)) return "".concat(get(DSTheme, width));
  if (typeof width === 'string') return width;
  var den = width < 1 ? Math.floor(1 / width) : width;
  return "".concat(den, "fr");
}
function mapTemplateGrid(grid) {
  if (Array.isArray(grid)) {
    if (grid.some(function (w) {
      return typeof w === 'string';
    })) return grid.map(function (w) {
      return mapGrid(w);
    });
    return numbersToFr(grid);
  }

  return mapGrid(grid);
}

export { fixSpace, fixSpaceGutter, mapGap, mapGrid, mapGutter, mapSpace, mapTemplateGrid, numbersToFr };
//# sourceMappingURL=spaceUtils.js.map
